import React, { ChangeEventHandler } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from "@material-ui/core";

type OutlineTextFieldProps = {
  label: string;
  value: unknown;
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  error?: boolean;
  helperText?: string;
  type?: string;
  multiline?: boolean;
  rows?: string | number;
  marginBottom?: number;
  width?: string | number;
  disabled?: boolean;
};

export const OutlineTextField: React.VFC<OutlineTextFieldProps> = (props) => {
  // styles
  const useStyles = makeStyles({
    textField: {
      display: "block",
      margin: "auto",
      marginTop: 10,
      marginBottom: props.marginBottom ?? 30,
      width: props.width ?? "60%",
      minWidth: 300,
    },
  });
  const classes = useStyles();

  return (
    <div className={classes.textField}>
      <TextField
        label={props.label}
        value={props.value}
        onChange={props.onChange}
        error={props.error}
        helperText={props.helperText}
        type={props.type}
        variant="outlined"
        fullWidth
        multiline={props.multiline}
        rows={props.rows}
        disabled={props.disabled}
      />
    </div>
  );
};
